import React, { useCallback, useRef } from 'react';
import Link from 'next/link';
import { useDispatch, useSelector } from 'react-redux';
import authActions from '../../../store/actions/authActions';
import helpers from '../../../helpers/helpers';
import styles from './HeaderProfile.module.scss';
import IconChevronRight from '../../UI/Icons/IconChevronRight';

const HeaderProfile = ({ closeDropdown }) => {
  const dispatch = useDispatch();
  const username = useSelector((state) => state.auth.user?.name);
  const { balancesList } = useSelector((state) => state.balances);
  const { getTranslationText } = helpers;

  const onSignOut = useCallback(
    () => {
      closeDropdown();
      dispatch(authActions.signOut());
    },
    [],
  );

  return (
    <div
      className={styles.profile}
    >
      <div className={styles.profileHead}>
        <div className={styles.profileUsername} onClick={closeDropdown}>{username}</div>
        <div className={styles.profileLogout} onClick={onSignOut}>
          <Link href="/">
            <a>{getTranslationText('header.profile_signOut')}</a>
          </Link>
        </div>
      </div>
      <div onClick={closeDropdown}>
        <Link
          href="/cabinet/balance"
          as="/cabinet/balance"
        >
          <a className={styles.balance}>
            <i className={styles.balanceIcon}><IconChevronRight/></i>
            <span className={styles.balanceTitle}>{getTranslationText('header.profile_balance')}</span>
            <span className={styles.balanceItems}>
              {balancesList?.map((el) => (
                <span>
                  {el.currency.toUpperCase()}&nbsp;&nbsp;<strong>{el.balance}</strong>
                </span>
              ))}
            </span>
          </a>
        </Link>
      </div>
      <div className={styles.profileMenu}>
        <div onClick={closeDropdown}>
          <Link
            href="/cabinet/gallery"
            as="/cabinet/gallery"
          >
            <a className={styles.profileMenuLink}>
              {getTranslationText('header.profile_gallery')}
            </a>
          </Link>
        </div>
        <div onClick={closeDropdown}>
          <Link
            href="/cabinet/deals"
          >
            <a className={styles.profileMenuLink}>
              {getTranslationText('header.profile_deals')}
            </a>
          </Link>
        </div>
        <div onClick={closeDropdown}>
          <Link
            href="/cabinet/profile"
            as="/cabinet/profile"
          >
            <a className={styles.profileMenuLink}>
              {getTranslationText('header.profile_profile')}
            </a>
          </Link>
        </div>
        <div className={styles.profileMenuDivider}/>
        <div onClick={closeDropdown}>
          <Link
            href="/cabinet/support"
          >
            <a className={styles.profileMenuLink}>
              {getTranslationText('header.profile_support')}
            </a>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default HeaderProfile;
